import React from 'react';
import { Typography, Button, Row, Col } from 'components';
import { IconWrapper, Input, SunTextEditor } from 'components';
import styles from '../styles.module.scss';

const { Title } = Typography;

interface EmailSectionProps {
  suppliers: {
    languageId: string;
    languageName: string;
    flagLocation: string;
  }[];
  selectedLanguage: string;
  currentUserEmail: string;
  languageEmailSubject: Record<string, any>;
  languageEmailBody: Record<string, any>;
  handleLanguageChange: (value: string) => void;
  handleSubjectChange: (value: string) => void;
  handleBodyChange: (value: string) => void;
  uniqueLanguages: () => {
    languageId: string;
    languageName: string;
    flagLocation: string;
  }[];
}

export const EmailSection: React.FC<EmailSectionProps> = ({
  suppliers,
  selectedLanguage,
  currentUserEmail,
  languageEmailSubject,
  languageEmailBody,
  handleLanguageChange,
  handleSubjectChange,
  handleBodyChange,
  uniqueLanguages,
}) => {
  return (
    <>
      <Title level={5} className={styles.sectionTitle}>
        Email
      </Title>
      <Row gutter={[16, 16]}>
        {suppliers.length ? (
          <Col span={24}>
            <Row className={styles.languageSelector}>
              {uniqueLanguages().map((i) => (
                <Button
                  key={i.languageId}
                  type={selectedLanguage === i.languageId ? 'primary' : 'default'}
                  onClick={() => handleLanguageChange(i.languageId)}
                  className={styles.languageButton}
                >
                  <IconWrapper src={i?.flagLocation} /> {i.languageName}
                </Button>
              ))}
            </Row>
          </Col>
        ) : null}

        <Col span={12}>
          <Row gutter={16}>
            <Col span={24}>
              <div className={styles.emailLabel}>From</div>
            </Col>
            <Col span={24}>
              <Input value={currentUserEmail} disabled className={styles.emailInput} />
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <Row gutter={16}>
            <Col span={24}>
              <div className={styles.emailLabel}>Subject</div>
            </Col>
            <Col span={24}>
              <Input
                value={selectedLanguage ? languageEmailSubject[selectedLanguage] || '' : undefined}
                onChange={(e) => handleSubjectChange(e.target.value)}
                className={styles.emailInput}
                placeholder="Enter email subject"
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <div className={styles.emailLabel}>Email Body</div>
          <SunTextEditor
            value={selectedLanguage ? languageEmailBody[selectedLanguage] || '' : ''}
            onChange={handleBodyChange}
            className={styles.emailEditor}
          />
        </Col>
      </Row>
    </>
  );
};
